import { render, staticRenderFns } from "./CarouselCard.vue?vue&type=template&id=12d2ac5e&scoped=true"
import script from "./CarouselCard.vue?vue&type=script&lang=js"
export * from "./CarouselCard.vue?vue&type=script&lang=js"
import style0 from "./CarouselCard.vue?vue&type=style&index=0&id=12d2ac5e&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12d2ac5e",
  null
  
)

export default component.exports